import ComponentListing from '@components/component-listing';
import * as React from 'react';
export default {
  ComponentListing,
  React
};